import { useCallback } from 'react'
import { FC } from 'react'
import { SOCIAL_NETWORK } from '../../models/post'

import { AltSocialIcons } from '../UI/Icons/socials'

import './SocialToggler.scss'

type TSocialToggler = {
  socials: SOCIAL_NETWORK[]
  activeSocial: SOCIAL_NETWORK
  setActiveSocial: (arg: any) => any
  isChecked?: (arg: any) => any
}

const SocialToggler: FC<TSocialToggler> = ({
  socials,
  activeSocial,
  setActiveSocial,
  isChecked,
  children
}) => {
  return (
    <div className='social-toggler'>
      <div className='social-toggler__socials'>
        {socials.map((social: SOCIAL_NETWORK) => (
          <div
            key={`connected-social-${social}`}
            className={`social-toggler__socials__item ${activeSocial === social && 'active'}`}
            onClick={() => setActiveSocial(social)}
          >
            <div className={`social-toggler__socials__item__icon ${social}`}>
              {AltSocialIcons[social]}
            </div>
            <div className='social-backdrop'></div>
            {isChecked && isChecked(social) && <div className='social-active'></div>}
          </div>
        ))}
      </div>
      <div className='social-toggler__content'>{children}</div>
    </div>
  )
}

export default SocialToggler
